module.exports = __webpack_public_path__ + "static/neuralhack-437b5aa5317cc135718fa9e430b4d07b.jpg";